var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"parent":"true"}},[_c('div',{staticClass:"has-text-centered"},[_c('img',{attrs:{"src":require("@/assets/images/nbf.png"),"width":"100","height":"100"}}),_c('h2',{staticClass:"title"},[_vm._v("401")]),_c('h1',{staticClass:"calc-subtitle"},[_vm._v(" "+_vm._s(_vm.$t('Obehörig åtkomst'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }